// extracted by mini-css-extract-plugin
export default {"root":"VideoFromFile_root__nKVam","aspectWrapper":"VideoFromFile_aspectWrapper__IVwy3","rootForImage":"VideoFromFile_rootForImage__A8jYp"};